/* eslint-disable no-console */
import { API_ADDRESS, API_TIMEOUT, API_ADDRESS_DOSTARTU, API_ADDRESS_AP } from '../config'
import axios from 'axios'

axios.defaults.timeout = API_TIMEOUT
axios.defaults.withCredentials = true

const api = axios.create({
    baseURL: API_ADDRESS,
    headers: {
        Authorization: 'Basic cHVibGljQHB1YmxpYzpwdWJsaWM=',
    },
})

api.interceptors.response.use(
    response => response.data,
    error => {
        if (!error.response) {
            // Network issues.
            console.log(error)
        } else if (error.response.status >= 500) {
            // Server problem.
            console.log(error)
        } else {
            // Other error.
            console.log(error)
        }

        // Validation errors.
        const errors = error.response?.data?.errors || {}

        return Promise.reject(errors)
    }
)

const apiDostartu = axios.create({
    baseURL: API_ADDRESS_DOSTARTU,
})

apiDostartu.interceptors.response.use(
    response => response.data,
    error => {
        if (!error.response) {
            // Network issues.
            console.log(error)
        } else if (error.response.status >= 500) {
            // Server problem.
            console.log(error)
        } else {
            // Other error.
            console.log(error)
        }

        // Validation errors.
        const errors = error.response?.data?.errors || {}

        return Promise.reject(errors)
    }
)
const apiAP = axios.create({
    baseURL: API_ADDRESS_AP,
})

apiAP.interceptors.response.use(
    response => response.data,
    error => {
        if (!error.response) {
            // Network issues.
            console.log(error)
        } else if (error.response.status >= 500) {
            // Server problem.
            console.log(error)
        } else {
            // Other error.
            console.log(error)
        }

        // Validation errors.
        const errors = error.response?.data?.errors || {}

        return Promise.reject(errors)
    }
)

export { api, apiAP, apiDostartu }
